import InnerComponent from '@Components//Inventory/StockTransfer/StockTransferForm';
import orgContainer from '@Components/AppContainer';

const UpdateStockTransfer = () => ((orgContainer(InnerComponent)));
export default UpdateStockTransfer;
